import React from 'react';
import { motion } from 'framer-motion';

const SectionReveal = ({ children, className = '' }) => (
	<motion.div
		initial={{ opacity: 0, y: 48, rotate: -1 }}
		whileInView={{ opacity: 1, y: 0, rotate: 0 }}
		viewport={{ once: true, amount: 0.2 }}
		transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
		className={`relative ${className}`}
	>
		<motion.div
			initial={{ scaleX: 0, opacity: 0 }}
			whileInView={{ scaleX: [0, 1, 1, 0], opacity: [0, 1, 1, 0] }}
			viewport={{ once: true, amount: 0.2 }}
			transition={{ duration: 0.8, times: [0, 0.3, 0.7, 1] }}
			style={{ transformOrigin: 'left' }}
			className="absolute -top-1 left-0 right-0 h-1 bg-blorange pointer-events-none"
			aria-hidden="true"
		/>
		{children}
	</motion.div>
);

export default SectionReveal;
